import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import controlResultsAction from 'modules/controlResults/controlResults.action';
import controlInitAction from 'modules/controlInit/controlInit.action';
import templateAction from 'modules/template/template.action';
import { TOptionsQuery } from 'types/common';
import { AppState } from 'store';
import { templateModule, TTemplateState } from 'modules/template/template.reducer';
import AdmSampleDataSimulation from './AdmSampleDataSimulation';

const AdmSampleDataSimulationContainer = () => {
  const dispatch = useDispatch();
  const { currentGroup } = useSelector((state: AppState) => state.pages.groupsClass);
  const template = useSelector((state: AppState) => state.pages.template);
  const { controlResults } = useSelector((state: AppState) => state.pages.controlResults);
  const { controlInit } = useSelector((state: AppState) => state.pages.controlInit);
  const getAllControlResults = (params: TOptionsQuery) => {
    dispatch(controlResultsAction.getControlResults(params));
  };
  const getAllControlInits = (params: TOptionsQuery) => {
    dispatch(controlInitAction.getControlInit(params));
  };

  const updateTemplate = (
    data: { controlResult: number; controlInit: number },
    id: number,
    groupId: number,
    buttonFooterNext: boolean = false,
    buttonFooterPre: boolean = false,
  ) => {
    dispatch(
      templateAction.updateTemplateStepChooseControlResult({ data, id, groupId, buttonFooterNext, buttonFooterPre }),
    );
  };
  const saveTemplate = (data: TTemplateState) => {
    dispatch(templateModule.actions.saveTemplate(data));
  };
  return (
    <AdmSampleDataSimulation
      getAllControlResults={getAllControlResults}
      getAllControlInits={getAllControlInits}
      controlResults={controlResults}
      controlInits={controlInit}
      currentGroup={currentGroup}
      updateTemplate={updateTemplate}
      template={template}
      saveTemplate={saveTemplate}
    />
  );
};
export default AdmSampleDataSimulationContainer;
